"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var embed_api_1 = require("@widgetbot/embed-api");

var React = require("react");

var elements_1 = require("./elements");

var util_1 = require("./util");

var WidgetBot = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(WidgetBot, _React$PureComponent);

  var _super = _createSuper(WidgetBot);

  function WidgetBot() {
    var _this;

    _classCallCheck(this, WidgetBot);

    _this = _super.apply(this, arguments);
    _this.state = {
      url: null,
      id: util_1.generateUUID()
    };
    _this.api = new embed_api_1.Client({
      id: _this.state.id,
      iframe: null
    });
    return _this;
  }

  _createClass(WidgetBot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onAPI = this.props.onAPI;
      if (onAPI) onAPI(this.api);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          defer = _this$props.defer,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width,
          focusable = _this$props.focusable;
      return React.createElement("div", {
        className: className,
        style: Object.assign(Object.assign({}, elements_1.Root({
          width: width,
          height: height
        })), style)
      }, React.createElement("iframe", {
        src: defer ? '' : this.state.url,
        ref: function ref(_ref) {
          return _this2.api.iframe = _ref;
        },
        style: elements_1.Embed,
        tabIndex: focusable ? null : -1,
        title: "Discord chat embed"
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var shard = props.shard;
      if (!shard.startsWith('http')) shard = "https://".concat(shard);
      if (shard.endsWith('/')) shard = shard.substring(0, shard.length - 1);
      var params = Object.assign(Object.assign({}, props.options), {
        api: state.id
      });
      if (props.username) params.username = props.username;
      var url = "".concat(shard, "/channels/").concat(props.server).concat(props.channel ? "/".concat(props.channel) : '', "/").concat(util_1.searchParams(params));
      return {
        url: url
      };
    }
  }]);

  return WidgetBot;
}(React.PureComponent);

exports.default = WidgetBot;
WidgetBot.defaultProps = {
  server: '299881420891881473',
  shard: 'https://e.widgetbot.io',
  options: {},
  defer: false,
  focusable: true
};